"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizzlyQueryEngineApi = void 0;
const Api_1 = require("./Api");
const SQLPreviewError_1 = require("../errors/SQLPreviewError");
const FailedToResolveDataSets_1 = require("../errors/FailedToResolveDataSets");
const FailedToSetupProject_1 = require("../errors/FailedToSetupProject");
const errors_1 = require("../errors");
class VizzlyQueryEngineApi extends Api_1.Api {
    constructor(auth, host, extraHeaders) {
        super(auth, host, extraHeaders);
    }
    buildCreateDashboardRequest(params) {
        return {
            path: '/api/v1/dashboard',
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                dashboardAccessToken: this.auth.getDashboardAccessToken(),
                definition: params.definition,
                meta: params.metadata || params.meta || {},
                parentDashboardId: params.parentDashboardId,
                permissions: params.permissions,
            },
        };
    }
    buildFetchDashboardAccessTokensRequest(params) {
        return {
            path: '/api/v1/dashboard/access',
            method: 'post',
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
            body: {
                dashboardAccessToken: this.auth.getDashboardAccessToken(),
                projectAdminOverrideToken: this.auth.getProjectAdminOverrideToken(),
            },
        };
    }
    fetchGlobalLibraryAccessTokens(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildFetchGlobalLibraryAccessTokensRequest(params));
        });
    }
    buildFetchGlobalLibraryAccessTokensRequest(params) {
        return {
            path: '/api/v1/global-library/access',
            method: 'post',
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
            body: {
                dashboardAccessToken: this.auth.getDashboardAccessToken(),
                projectAdminOverrideToken: this.auth.getProjectAdminOverrideToken(),
            },
        };
    }
    buildFetchDashboardsRequest(params) {
        return {
            path: '/api/v1/get-dashboards',
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                dashboardAccessTokens: params.dashboardSessionAccessTokens,
            },
        };
    }
    createConfigFromUpload(createConfigFromUploadParams) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildCreateConfigFromUploadRequest(createConfigFromUploadParams));
        });
    }
    buildCreateConfigFromUploadRequest(params) {
        return {
            path: `/api/v1/create-config-from-upload`,
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                queryEngineAccessToken: this.auth.getQueryEngineAccessToken(),
                table: params.table,
                fieldPublicNames: params.fieldPublicNames,
            },
        };
    }
    createResults(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildCreateResultsRequest(params));
        });
    }
    buildCreateResultsRequest(params) {
        return {
            path: `/api/v1/create-results`,
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                queries: params.queries,
                virtualFields: {},
                identityConfigIntegritySignature: this.auth.getDataAccessToken(),
            },
        };
    }
    createSqlPreview(params) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const response = yield this.execute(this.buildCreateSqlPreviewRequest(params));
            if (response.status === 200)
                return response;
            throw new SQLPreviewError_1.SQLPreviewError(((_a = response === null || response === void 0 ? void 0 : response.body) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown SQL error');
        });
    }
    buildCreateSqlPreviewRequest(params) {
        return {
            path: `/api/v1/create-sql-preview`,
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                sql: params.sql,
                parameters: params.parameters,
                limit: params.limit,
            },
        };
    }
    createQueryEngineUser(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildCreateQueryEngineUserRequest(params));
        });
    }
    buildCreateQueryEngineUserRequest(params) {
        return {
            path: `/api/v1/query-engine-user`,
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                email: params.email,
                password: params.password,
            },
        };
    }
    fetchDataSets(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.buildFetchDataSetsRequest(params);
            const result = yield this.execute(request);
            if (result.status === 200)
                return result;
            throw new FailedToResolveDataSets_1.FailedToResolveDataSets(`Failed to resolve data sets from ${request.path}. Received status ${result.status}`);
        });
    }
    buildFetchDataSetsRequest(params) {
        return {
            path: `/api/v1/resolve-data-sets`,
            method: 'post',
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
            body: {
                integritySignature: this.auth.getDataAccessToken(),
            },
        };
    }
    fetchSelfHostedQueryEngineConfig(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.execute(this.buildFetchSelfHostedQueryEngineConfigRequest(params));
        });
    }
    buildFetchSelfHostedQueryEngineConfigRequest(params) {
        return {
            path: `/api/v1/support`,
            method: 'post',
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
            body: {},
        };
    }
    fetchProject(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.execute(this.buildFetchProjectRequest(params));
        });
    }
    buildFetchProjectRequest(params) {
        return {
            path: `/api/v1/project`,
            method: 'get',
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
            body: {},
        };
    }
    getStarted(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute(this.buildGetStartedRequest(params));
            if (response.status != 200) {
                throw new FailedToSetupProject_1.FailedToSetupProject(typeof response.body === 'object' && response.body.reason && 'reason' in response.body
                    ? response.body.reason
                    : 'Failed to create the first user.');
            }
            return response;
        });
    }
    buildGetStartedRequest(params) {
        return {
            path: `/api/v2/get-started`,
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                email: params.email,
                password: params.password,
            },
        };
    }
    getTeamMembers(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.execute(this.buildGetTeamMembersRequest(params));
        });
    }
    buildGetTeamMembersRequest(params) {
        return {
            path: `/api/v1/team-members`,
            method: 'get',
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
        };
    }
    isVizzly(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.execute(this.buildIsVizzlyRequest(params));
        });
    }
    buildIsVizzlyRequest(params) {
        return {
            path: `/api/is-vizzly`,
            method: 'get',
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
        };
    }
    saveConfig(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildSaveConfigRequest(params));
        });
    }
    buildSaveConfigRequest(params) {
        return {
            path: `/api/v1/save-config`,
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                config: params.config,
            },
        };
    }
    saveConnection(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildSaveConnectionRequest(params));
        });
    }
    buildSaveConnectionRequest(params) {
        return {
            path: `/api/v1/save-connection`,
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                connection: params.connection,
                client: params.client,
            },
        };
    }
    signInWithQueryEngineAccessToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.execute(this.buildSignInWithQueryEngineAccessTokenRequest(params));
        });
    }
    buildSignInWithQueryEngineAccessTokenRequest(params) {
        return {
            path: `/api/v1/sign-in`,
            method: 'post',
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
            body: {},
        };
    }
    signInWithEmailAndPassword(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildSignInWithEmailAndPasswordRequest(params));
        });
    }
    buildSignInWithEmailAndPasswordRequest(params) {
        return {
            path: `/api/v1/sign-in`,
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                email: params.email,
                password: params.password,
            },
        };
    }
    status(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.execute(this.buildStatusRequest(params));
        });
    }
    buildStatusRequest(params) {
        return {
            path: `/api/status`,
            method: 'post',
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
            body: {},
        };
    }
    createGlobalLibrary(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.execute(this.buildCreateGlobalLibraryRequest(params));
            if (result.status === 200)
                return result.body;
            throw new errors_1.FailedToCreateGlobalLibrary(`Failed to create a global library. Got status ${result.status}`);
        });
    }
    buildCreateGlobalLibraryRequest(params) {
        return {
            path: '/api/v1/global-library',
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                dashboardAccessToken: this.auth.getDashboardAccessToken(),
                parentGlobalLibraryId: params.parentGlobalLibraryId,
                library: params.library,
                permissions: params.permissions,
            },
        };
    }
    fetchGlobalLibraries(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildFetchGlobalLibrariesRequest(params));
        });
    }
    buildFetchGlobalLibrariesRequest(params) {
        return {
            path: '/api/v1/get-global-libraries',
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                globalLibraryAccessTokens: params.globalLibraryAccessTokens,
            },
        };
    }
    updateGlobalLibrary(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildUpdateGlobalLibraryRequest(params));
        });
    }
    buildUpdateGlobalLibraryRequest(params) {
        return {
            path: '/api/v1/global-library',
            method: 'put',
            abortSignal: params.abortSignal,
            body: {
                globalLibrarySessionToken: params.globalLibrarySessionToken,
                deleted: params.deleted,
                library: params.library,
            },
        };
    }
    updateDashboard(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildUpdateDashboardRequest(params));
        });
    }
    buildUpdateDashboardRequest(params) {
        return {
            path: `/api/v1/dashboard`,
            method: 'put',
            abortSignal: params.abortSignal,
            body: {
                dashboardSessionToken: params.dashboardPermission.token,
                definition: params.definition,
                meta: params.metadata || params.meta || {},
                deleted: params.deleted,
            },
        };
    }
    updateQueryEngineUser(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildUpdateQueryEngineUserRequest(params));
        });
    }
    buildUpdateQueryEngineUserRequest(params) {
        return {
            path: `/api/v1/query-engine-user`,
            method: 'put',
            abortSignal: params.abortSignal,
            body: {
                queryEngineUserId: params.queryEngineUserId,
                password: params.password,
            },
        };
    }
    uploadDataToVizzlyCloud(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildUploadDataToVizzlyCloudRequest(params));
        });
    }
    buildUploadDataToVizzlyCloudRequest(params) {
        return {
            path: `/api/v1/ingest`,
            method: 'post',
            abortSignal: params.abortSignal,
            body: {
                queryEngineAccessToken: this.auth.getQueryEngineAccessToken(),
                ingest: params.ingest,
            },
        };
    }
}
exports.VizzlyQueryEngineApi = VizzlyQueryEngineApi;
